// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

const updateAccordionItemHeight = (item) => {
  if (!item) {
    return;
  }

  const summary = item.querySelector('.accordion__summary');
  const content = item.querySelector('.accordion__body');

  if (!summary || !content) {
    return;
  }

  item.style.height = `${summary.offsetHeight + (item.open ? content.scrollHeight : 0)}px`;
};

const updateItem = (item) => {
  const itemSummary = item.querySelector('.accordion__summary');

  if (!itemSummary) {
    return;
  }

  itemSummary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
  updateAccordionItemHeight(item);
};

const updateAccordion = (accordion, activeItem, shouldOpen) => {
  const items = accordion ? Array.from(accordion.querySelectorAll('.accordion__item')) : [activeItem];

  items.forEach((item) => {
    item.open = item === activeItem ? shouldOpen : false;
    updateItem(item);
  });
};

// Opens a `.accordion__item` from outside the accordion's own click handling
// (e.g. a map pin popup's "Show Details" button) — closes any sibling item
// in the same `.accordion`, same as clicking its summary would.
export const openAccordionItem = (details) => {
  updateAccordion(details.closest('.accordion'), details, true);
};

// Cross-script access for consumers loaded as separate Vite entrypoints
// (e.g. location-finder.js), which can't ES-import across content-element
// package boundaries the way a single bundle could.
window.AltanaAccordion = { open: openAccordionItem };

const setupAccordionItem = (details) => {
  const summary = details.querySelector('.accordion__summary');
  const content = details.querySelector('.accordion__body');

  if (!summary || !content) {
    return;
  }

  const accordion = details.closest('.accordion');
  const requiresOpen = !!(accordion?.hasAttribute('data-accordion-required-open') && accordion?.getAttribute('data-accordion-required-open') !== 'false');

  const onResize = () => {
    requestAnimationFrame(() => updateItem(details));
  };

  updateItem(details);

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    updateAccordion(accordion, details, requiresOpen ? true : !details.open);
  });

  window.addEventListener('resize', onResize, { once: false });

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(onResize);

    resizeObserver.observe(summary);
    resizeObserver.observe(content);
  }
};

document.querySelectorAll('.accordion__item').forEach(setupAccordionItem);

import './accordion.scss';
